import React from 'react';
import TopBanner from '../MainContents/TopBanner'; 
import FlowJoin from './FlowText'; 
import Enter from './EnteringRoomTest'; 
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';

const MarginWid = styled.div`
  margin: 0 auto;
  width: 80%;
  text-align: center;
  @media ${device.mobile}{
      text-align: left;
  }
`;
const Margin = styled.p`margin:30px 0px 30px`;
const PageColor = styled.div`background-color: rgb(242, 242, 242)`;

const Join = () => {
    const url ='/yotsutaninet/Join';
    return (
    
    <PageColor>   
    <ScrollToTopOnMount />
        {/* 入塾までの流れ */}
            <TopBanner  title="入塾の流れ" text1="入塾までの流れについてご確認ください" text2="お問い合わせ～個別説明会＆授業体験～入塾面談～入塾" />
   
            <MarginWid className="center">
                <FlowJoin id="1" title="お問い合わせ"   urlAddress="https://www.tosajuku.com/mail/" btn="btn btn-primary" btnTitle="お問い合わせ" 
                    text1="お電話・メール・お問い合わせフォームからご連絡ください。"
                    text2="Tel:088-813-9007" 
                    text3="受付時間は14:00～21:30(土日、祝日除く)"
                />

                <FlowJoin id="2" title="個別説明会＆授業体験"  text1="教室にて個別説明会と授業体験を実施いたします。" text2="指導方針にご納得いただき、生徒のみなさんが体験する授業で満足できるかをお確かめください。" />
                
                <FlowJoin id="3" title="入室テスト or 公開模試にてランキング入り" 
                    urlAddress={url + "#detail"}　detail="詳細はこちら" 
                    text1="入室には条件があります。"
                    text2="3YTコースの入室条件(入室テストやその他条件)はありません。"
                />
              
                <FlowJoin id="4" title="入塾面談" text1="入塾のご希望が固まりましたら、入塾面談を行います。" text2="カリキュラムやテキスト・テストのご説明や、諸費用などの確認をさせていただきます。"  text3="事務的な手続きも入塾面談時に併せて行います。"/>
                
                <FlowJoin id="5" title="入塾" text1="今日から土佐塾はりまやYT教室生です。初心を忘れず、一緒に頑張っていきましょう。" />
                
                <Margin></Margin>
              
            </MarginWid>
            <Enter />
                 <Margin></Margin>
    </PageColor>
    );
  };

export default Join;